import { IconButton, IconTypesKeys } from "@evergis/ui";
import React, { FC } from "react";
import { TagsContainer } from "./Edit/styled";
import { FilterSelectorChip } from "./ResourceFilters/styled";

export interface TagsListProps {
  className?: string;
  tags: string[];
  editable?: boolean;
  deleteIcon?: IconTypesKeys;
  onTagDelete?: (tag: string) => void;
}

export const TagsList: FC<TagsListProps> = ({
  className,
  tags,
  deleteIcon = "delete",
  editable = true,
  onTagDelete,
}) => (
  <TagsContainer className={className}>
    {tags.map(tag => (
      <FilterSelectorChip disabled={!editable}>
        <div>{tag}</div>
        {onTagDelete && <IconButton kind={deleteIcon} onClick={() => onTagDelete(tag)} />}
      </FilterSelectorChip>
    ))}
  </TagsContainer>
);
